import { Response, httpGet, httpPatch, httpPost, httpPut } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

import { GameRatingBodyProps, ReviewListBodyProps } from "./review.type";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {};

const reviewPlayersList = createAsyncThunk(
  "review/Review Players",
  async (body: ReviewListBodyProps) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPut(`${REACT_APP_BASE_URL}/api/v1/player-reviews/`, body, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const gameRating = createAsyncThunk(
  "review/rate game",
  async (body: GameRatingBodyProps) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPost(`${REACT_APP_BASE_URL}/api/v1/game-reviews/`, body, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const getGameReviews = createAsyncThunk(
  "review/get all review for a game by id",
  async (gameId: string) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(
          `${REACT_APP_BASE_URL}/api/v1/game-reviews/?game_id=${gameId}`,
          true
        )
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const getGameReviewById = createAsyncThunk(
  "review/get review for a game by id",
  async (reviewId: string) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(`${REACT_APP_BASE_URL}/api/v1/game-reviews/${reviewId}`, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const getGameReviewAndAverage = createAsyncThunk(
  "review/get review for a game by id",
  async (gameId: string) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(
          `${REACT_APP_BASE_URL}/api/v1/game-reviews/stats?game_id=${gameId}`,
          true
        )
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);
const reviewSlice = createSlice({
  name: "review",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const reviewReducer = reviewSlice.reducer;

export const reviewActions = {
  ...reviewSlice.actions,
  reviewPlayersList,
  gameRating,
  getGameReviews,
  getGameReviewById,
  getGameReviewAndAverage,
};
